import React, { useState } from 'react'
import type { FC } from 'react'
import { createStyles, makeStyles } from '@material-ui/core/styles'
import { useHistory } from 'react-router-dom'

import { Button } from '@homeviews/shared-ui'
import { mixpanelTrack } from '@homeviews/seo'
import { Modal, Typography } from '@homeviews/outreach'

const useStyles = makeStyles((theme) =>
  createStyles({
    wrapper: {
      display: 'inline-block',
      position: 'relative',
      marginRight: '20px',
      marginBottom: '19px',
    },
    innerWrapper: {
      marginBottom: '13px',
      '&:hover': {
        cursor: 'pointer',
        '& $button': {
          display: 'block',
        },
        '& $img': {
          filter: 'brightness(50%)',
        },
      },
    },
    button: {
      display: 'none',
      position: 'absolute',
      top: '71px',
      left: '22px',
      width: '193px',
      padding: '11px 11px 12px 12px',
    },
    img: {
      display: 'inline-block',
      borderRadius: '3px',
      backgroundColor: 'rgba(0, 0, 0, 0.02)',
      transition: '0.25s filter cubic-bezier(0.4, 0, 0.2, 1)',
    },
    customBody1: {
      '.MuiTypography-body1&': {
        marginTop: 0,
        marginBottom: 0,
        textTransform: 'capitalize',
      },
    },
    previewButton: {
      height: '23px',
      marginTop: '10px',
      paddingRight: '15px',
      paddingLeft: '15px',
      border: '1px solid #DEE1E6',
      borderRadius: '11.5px',
      letterSpacing: '-0.23px',
      color: theme.colors.grey600,
    },
  }),
)

export type TemplateSlugs =
  | 'new-tenant-email'
  | 'long-tenant-email'
  | 'exit-tenant-email'
  | 'promotion-resident-email'

type SelectEmailProps = {
  templateSlug: TemplateSlugs
  title: string
}

export const SelectEmail: FC<SelectEmailProps> = ({ templateSlug, title }) => {
  const [showModal, setShowModal] = useState(false)
  const toggleShowModal = () => setShowModal(!showModal)
  const classes = useStyles()
  const history = useHistory()

  const handleOnClickSelectEmail = () => {
    mixpanelTrack('Outreach: Select Email Template', { 'Template Name': title })
    history.push(`/outreach/${templateSlug}`)
  }

  return (
    <>
      <div className={classes.wrapper}>
        <div
          className={classes.innerWrapper}
          onClick={handleOnClickSelectEmail}
        >
          <img
            className={classes.img}
            src={`assets/images/outreach-${templateSlug}.png`}
            alt={`Select ${title}`}
            width="238"
            height="180"
          />
          <Button className={classes.button} customColor="primary">
            Select email
          </Button>
        </div>
        <Typography variant="body1" className={classes.customBody1}>
          {title}
        </Typography>
        <Button className={classes.previewButton} onClick={toggleShowModal}>
          See Preview
        </Button>
      </div>
      {showModal && (
        <Modal
          emailTemplateSlug={templateSlug}
          closeOnClick={() => toggleShowModal()}
          primaryOnClick={() => toggleShowModal()}
        />
      )}
    </>
  )
}
